import { BaseLayer } from "./BaseLayer";

export class FsrLocationsLayer extends BaseLayer {
  constructor(map, apiUrl, exportUrl, csrfToken) {
    super(map, apiUrl, exportUrl, csrfToken);
    this.toggleButton = document.getElementById("button-map-fsr");
    this.markerTitle = "FSR Location";
    this.layerName = "FsrLocationsLaye";
    this.exportName = "FSR Locations";
    this.create();
  }

  showInfoWindow(event) {
    const feature = event.feature;

    const certificationLevelName =
      feature.getProperty("certification_level_name") === undefined
        ? "N/A"
        : "" + feature.getProperty("certification_level_name");

    const listItems = [
      '<i class="fa-li fa fa-globe-europe"></i> Location: ' + feature.getProperty("location"),
      '<i class="fa-li fa fa-file"></i> Security Level: ' + certificationLevelName,
    ];

    this.createInfoWindow(listItems, event);
  }
}
